setTimeout(() =>
{
  let flash = document.getElementsByClassName('flash')[0]
  if (flash) {
    flash.outerHTML = ''
  }
}, 5000);
